import { api } from 'src/pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';

export default class GenericApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public get(url: string): Promise<any> {
    return super.get(url);
  }

  public postRequest(url: string, dataMap: Map<string, any>): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of dataMap) {
      formData.append(key, value);
    }
    return super.post(url, formData);
  }

  public deleteRequest(url: string, dataMap: Map<string, any>): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of dataMap) {
      formData.append(key, value);
    }

    formData.append('org_id', this.getOrgId());
    return super.delete(url, formData);
  }
}
